import { useEffect, useState } from 'react';
import { useAuth } from '../../context/useAuth';
import {
  buildEnrollSuccessMessage,
  dismissEnrollBanner,
  listActiveEnrollBanners,
} from '../../utils/liveClassEnrollBanner';

/**
 * Mensajes anclados post-inscripción; visibles en Inicio/calendario hasta fin de clase.
 */
export default function LiveClassEnrollBanner({ compact = false }) {
  const { user } = useAuth();
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    if (!user?.id) {
      setBanners([]);
      return undefined;
    }
    const refresh = () => setBanners(listActiveEnrollBanners(user.id));
    refresh();
    const onChange = () => refresh();
    window.addEventListener('d28d:enroll-banner:changed', onChange);
    const tick = window.setInterval(refresh, 15_000);
    return () => {
      window.removeEventListener('d28d:enroll-banner:changed', onChange);
      window.clearInterval(tick);
    };
  }, [user?.id]);

  if (!banners.length) return null;

  return (
    <div className={compact ? 'ef-enroll-banner-stack ef-enroll-banner-stack--compact' : 'ef-enroll-banner-stack'} role="status">
      {banners.map((b) => (
        <div key={`${b.classId}-${b.expiresAt}`} className="ef-enroll-banner">
          <p className="ef-enroll-banner__text">
            {buildEnrollSuccessMessage(b.classTitle)}
          </p>
          <button
            type="button"
            className="btn btn-secondary text-xs shrink-0"
            aria-label="Cerrar aviso"
            onClick={() => dismissEnrollBanner(user.id, b.classId)}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
